<script lang="ts">
  import { untrack } from "svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import CreateWorkflowActionBox from "../../../../../../../../_shared/_modules/create-workflow-action-box"
  import CreateWorkflowStepFrame from "../../../../../../../../_shared/_modules/create-workflow-step-frame"
  import CreateBlockerAction from "./_modules/create-blocker-action"
  import type {
    BlockerConfigurationOutput,
    BlockerCreateInit,
    BlockerDetailsOutput,
    BlockerGeneralOutput,
  } from "../../_shared/_logic/create-blocker-contract"

  type Props = {
    init: BlockerCreateInit
    general: BlockerGeneralOutput
    configuration: BlockerConfigurationOutput
    output?: BlockerDetailsOutput
    readOnly?: boolean
    onBack: () => void
    onCreated: (events: ScheduleEvent[]) => Promise<void> | void
    onClose: () => void
    onError?: (message: string | null) => void
  }

  const {
    init,
    general,
    configuration,
    output = undefined,
    readOnly = false,
    onBack,
    onCreated,
    onClose,
    onError = () => {},
  }: Props = $props()

  const initialDetails = untrack(() => ({
    title: output?.title ?? (general.eventType === "ABSENCE" ? "Abwesenheit" : "Interner Blocker"),
    description: output?.description ?? "",
    locationText: output?.locationText ?? "",
  }))

  let title = $state(initialDetails.title)
  let description = $state(initialDetails.description)
  let locationText = $state(initialDetails.locationText)
  const validationMessage = $derived(title.trim() ? null : "Bitte einen Titel angeben.")
  const canCreate = $derived(!validationMessage)

  const outputValue = $derived<BlockerDetailsOutput>({
    title,
    description,
    locationText,
  })
</script>

<form onsubmit={(event) => event.preventDefault()}>
  <CreateWorkflowStepFrame
    title="Details"
    description="Geben Sie einen eindeutigen Namen an, damit der Eintrag später im Kalender verständlich ist."
    helpModalTextId="blockerCreateDetails"
  >
    <CreateWorkflowActionBox label="Beschreibung">
      <p
        >Der Titel erscheint im Kalender. Ort und Notizen helfen später beim Einordnen des Blockers.</p
      >
      <div class="create-workflow-field-grid">
        <Input placeholder="Titel" bind:value={title} surfaceTone="dark" disabled={readOnly} />
        <Input
          placeholder="Ort / Hinweis"
          bind:value={locationText}
          surfaceTone="dark"
          disabled={readOnly}
        />
      </div>
      <div class="create-workflow-field-grid">
        <Input
          type="textarea"
          placeholder="Beschreibung / Notizen"
          bind:value={description}
          surfaceTone="dark"
          disabled={readOnly}
        />
      </div>
    </CreateWorkflowActionBox>
  </CreateWorkflowStepFrame>
  {#if !readOnly}
    <div class="step-actions">
      <CTA type="secondaryButton" content="Zurück" onClick={onBack} />
      <CreateBlockerAction
        {init}
        {general}
        {configuration}
        details={outputValue}
        disabled={!canCreate}
        disabledReason={validationMessage}
        {onCreated}
        {onClose}
        {onError}
      />
    </div>
  {/if}
</form>

<style>
  .step-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 0.4rem;
  }
</style>
